import merge from 'lodash-es/merge';
import getDefaultStyle from '../css/defaultStyle';
import updateClass from '../css/updateClass';
import updateStyleByRef from '../css/updateStyleByRef';
import cloneDeep from 'lodash-es/cloneDeep';
import get from 'lodash-es/get';
import omit from 'lodash-es/omit';
import isEqual from 'lodash-es/isEqual';
import lookAndFeel from '../lookAndFeel';
import frameProps from '../css/frameProps';
import getDisabledStyle from '../css/disabledStyle';

const mainCSS = [
  {
    selector: '.body',
    properties: merge({},        
         /*getDefaultStyle(),*/ {
        position: 'static',
        /*transitionProperty: 'all',
        transitionDuration: '${schemeAnimationDuration}',
        transitionTimingFunction: 'ease',
        transitionDelay: '0s',
        position: 'absolute',
        padding: '${schemePaddingTop} calc(${schemeFontSize} / 2)',
        display: 'block',
        borderStyle: 'none',
        borderColor: '${schemeShade}',
        borderWidth: '1px',
        borderRadius: '4px',
        textShadow: '0 2px 2px ${schemeShade}',
        color: '${schemeForeground}',
        overflow: 'hidden',
        fontSize: '${schemeFontSize}',
        top: '8px',
        left: '8px',
        width: 'auto',
        height: 'auto',
        userSelect: 'none',*/
      }),
  },
];
// export function getDefaultControlStyle() {
//   if (!getDefaultControlStyle.style) {
//     getDefaultControlStyle.style = {
//       normal: merge({}, getDefaultStyle(), {
//         transitionProperty: 'all',
//         transitionDuration: '${schemeAnimationDuration}',
//         transitionTimingFunction: 'ease',
//         transitionDelay: '0s',
//         position: 'absolute',
//         padding: '${schemePaddingTop} calc(${schemeFontSize} / 2)',
//         display: 'block',
//         borderStyle: 'none',
//         borderColor: '${schemeShade}',
//         borderWidth: '1px',
//         borderRadius: '4px',
//         textShadow: '0 2px 2px ${schemeShade}',
//         color: '${schemeForeground}',
//         overflow: 'hidden',
//         fontSize: '${schemeFontSize}',
//         top: '8px',
//         left: '8px',
//         width: '120px',
//         height: '32px',
//         userSelect: 'none',
//       }),
//     };
//   }

//   return getDefaultControlStyle.style;
// }

export function getDefaultControl() {
  if (!getDefaultControl.source) {
    getDefaultControl.source = document.createElement('div');
    getDefaultControl.source.classList.add('controls');
    getDefaultControl.source.innerHTML = 
      `<video controls class="body" style="position:absolute;top:0;right:0;bottom:0;left:0;overflow:hidden;width:100%;height:100%;">
        Your browser does not support the video element.
      </video>`;
  }

  return getDefaultControl.source.cloneNode(true);
}

export function updateClasses(control, options) {
    let normal = get(options, 'style.normal');    
    let scheme = lookAndFeel(options.lookAndFeel, normal.height);

    if (control.disabled) {
      normal = merge({},normal, getDisabledStyle());
      if (options.style && options.style.disabled) {
        merge(normal, options.style.disabled);
      }

    }

    if (control.isLayoutMode) {
      normal.pointerEvents='none';
    }

    let CSS = updateStyleByRef(
      merge(cloneDeep(mainCSS), [
        {
          // body
          properties: omit(normal, frameProps),
        },        
      ]),
      scheme
    );

    if (isEqual(control.CSS, CSS)) {
      return;
    }

    control.CSS = CSS;
    control.styleSheet = updateClass(control.styleSheet, CSS, '#' + control.id);
  }
